// Human-friendly label for a connected store: the admin-set nickname when
// present, otherwise the myshopify domain with the ".myshopify.com" suffix
// stripped. Use this everywhere a store is shown so nicknames apply uniformly.
export const storeLabel = (store) => {
  if (!store) return '';
  const nick = (store.nickname || '').trim();
  if (nick) return nick;
  return (store.shop_domain || '').replace('.myshopify.com', '');
};

export default storeLabel;
